<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    top?: boolean | null
    bottom?: boolean | null
    left?: boolean | null
    chevron?: boolean
    size?: number | string
    height?: number | string
    stroke?: number | string
    length?: number
    arrowHeight?: number
    disabled?: boolean
  }>(),
  {
    top: false,
    bottom: false,
    left: false,
    size: 24,
    stroke: 2,
    height: 0,
    length: 7,
    arrowHeight: 5,
  },
)

const ui = computed(() => {
  const { left, top, bottom, length, arrowHeight } = props
  const ver = top || bottom

  const lineA = 12 + length
  const lineB = 12 - length

  const p1 = 12 - arrowHeight
  const p2 = 12 + arrowHeight

  const [t, b, c] = left || top ? [p2, p1, lineB] : [p1, p2, lineA]

  return {
    polyline: ver ? `${t} 12 12 ${c} ${b} 12` : `12 ${t} ${c} 12 12 ${b}`,
    line: ver ? { y1: lineA, y2: lineB, x1: 12, x2: 14 } : { y1: 12, y2: 12, x1: lineA, x2: lineB },
  }
})
</script>

<template>
  <svg
    :class="[left ? $style.l : $style.r, disabled ? $style.off : $style.arr]"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="{ width: size, height: height || size }"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="stroke"
    stroke-linejoin="round"
  >
    <!-- stroke-linecap="round" -->
    <line v-if="!chevron" :class="$style.line" v-bind="ui.line" />
    <polyline :class="$style.pol" :points="ui.polyline" />
  </svg>
</template>

<style module>
:global(.IconArrow) .pol {
  transform: translate3d(-15%, 0, 0);
  transition: transform 160ms var(--tran1);
}
:global(.IconArrow) .line {
  transform: scale3d(0, 1, 1);
  transition:
    transform 160ms var(--tran1),
    opacity 160ms var(--tran1);
  transform-origin: center center;
  opacity: 0.01;
}
:global(.IconArrow).l .pol,
:global(.IconArrow) .l .pol {
  transform: translate3d(15%, 0, 0);
}
:global(.d) :global(.IconArrow):hover .arr .pol,
:global(.IconArrow):focus-visible .arr .pol,
:global(.IconArrowOn) .pol {
  transform: translate3d(0, 0, 0);
}
:global(.d) :global(.IconArrow):hover .arr .line,
:global(.IconArrow):focus-visible .arr .line,
:global(.IconArrowOn) .line {
  transform: scale3d(1, 1, 1);
  opacity: 0.99;
}
</style>
